import * as React from 'react'
import { SVGProps } from 'react'
const SvgPinCodelockIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='m16.06 31.53 9.114-9.115c4.977-4.977 4.977-13.121-.064-18.163a12.874 12.874 0 0 0-18.228 0 12.874 12.874 0 0 0 0 18.228l9.179 9.05Z'
      fill='currentColor'
    />
    <path
      d='m16.06 31.53 9.114-9.115c4.977-4.977 4.977-13.121-.064-18.163a12.874 12.874 0 0 0-18.228 0 12.874 12.874 0 0 0 0 18.228l9.179 9.05Z'
      fill='url(#pin_codelock_icon_svg__a)'
      fillOpacity={0.25}
    />
    <path
      d='m16.06 31.53 9.114-9.115c4.977-4.977 4.977-13.121-.064-18.163a12.874 12.874 0 0 0-18.228 0 12.874 12.874 0 0 0 0 18.228l9.179 9.05Z'
      fill='url(#pin_codelock_icon_svg__b)'
      fillOpacity={0.25}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.413 10.346a.437.437 0 0 0-.437.437v5.25a.437.437 0 0 0 .437.437h6.125a.438.438 0 0 1 0 .876h-6.125A1.313 1.313 0 0 1 9.1 16.033v-5.25c0-.348.138-.682.385-.928m0 0c.246-.247.58-.385.928-.385h10.5a1.313 1.313 0 0 1 1.313 1.313v3.5a.438.438 0 1 1-.876 0v-3.5a.437.437 0 0 0-.437-.437h-10.5m1.093 3.062a.657.657 0 1 1 1.314 0 .657.657 0 0 1-1.314 0Zm3.5 0a.657.657 0 1 1 1.314 0 .657.657 0 0 1-1.314 0Zm3.5 0a.657.657 0 1 1 1.314 0 .657.657 0 0 1-1.314 0Zm-.015 2.828a2.188 2.188 0 0 1 3.735 1.547v.512c.51.18.875.667.875 1.238v2.625c0 .726-.588 1.313-1.313 1.313h-3.5a1.313 1.313 0 0 1-1.313-1.313v-2.625c0-.571.365-1.058.875-1.238v-.512c0-.58.23-1.137.64-1.547Zm.235 1.984h2.624v-.437a1.312 1.312 0 1 0-2.624 0v.437Zm-.438.877a.437.437 0 0 0-.437.436v2.625c0 .241.196.437.437.437h3.5a.437.437 0 0 0 .437-.437v-2.625a.437.437 0 0 0-.437-.437h-3.5Zm1.093 1.766a.657.657 0 1 1 1.314 0 .657.657 0 0 1-1.314 0Z'
      fill='#fff'
    />
    <defs>
      <linearGradient
        id='pin_codelock_icon_svg__a'
        x1={16}
        y1={0.471}
        x2={16}
        y2={31.529}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#fff' />
        <stop offset={1} stopColor='#fff' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='pin_codelock_icon_svg__b'
        x1={16}
        y1={0.471}
        x2={16}
        y2={31.529}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#fff' />
        <stop offset={1} stopColor='#fff' stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgPinCodelockIcon
